import { render, staticRenderFns } from "./pieChart1.vue?vue&type=template&id=151d94fb"
import script from "./pieChart1.vue?vue&type=script&lang=js"
export * from "./pieChart1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports